<template>
  <v-row style="background-color: #eee">
    <YourArticleInfoDialog ref="yourArticleInfoDialog"></YourArticleInfoDialog>
    <v-col md="12" v-if="$vuetify.breakpoint.smAndUp">
      <div class="pb-5 d-flex">
        <span class="display-1 pt-1 font-weight-bold">{{
          $t("yourArticles.general.Your Articles")
        }}</span>
        <span>
          <v-btn
            :title="$t('yourArticles.general.Click to see more information')"
            @click.stop="$refs.yourArticleInfoDialog.openDialog()"
            icon
            large
          >
            <v-icon color="primary">far fa-question-circle</v-icon>
          </v-btn>
        </span>
      </div>
    </v-col>
    <!--Phone-->
    <v-col v-else class="ma-0 pa-0" cols="12">
      <v-row class="ma-0 pa-0">
        <!--Title-->
        <v-col class="ma-0 pa-0 pl-10 pt-3" cols="8">
          <span class="display-1 pt-1 font-weight-bold">{{
            $t("yourArticles.general.Your Articles")
          }}</span>
        </v-col>
        <!--Help button-->
        <v-col class="ma-0 pa-0 pt-3">
          <v-btn
            :title="$t('yourArticles.general.Click to see more information')"
            @click.stop="$refs.yourArticleInfoDialog.openDialog()"
            icon
            large
          >
            <v-icon color="primary">far fa-question-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col md="12">
      <ArticleListCard></ArticleListCard>
    </v-col>
  </v-row>
</template>
<script>
import messages from "./modules/lang/main/export";
import ArticleListTable from "@/pages/private/components/table/articleListTable.vue";
import ArticleListCard from "@/pages/private/components/card/articleListCard.vue";
import YourArticleInfoDialog from "@/components/informational_dialogs/private/yourArticles_info_dialog.vue";
export default {
  i18n: { messages },
  components: {
    ArticleListTable,
    ArticleListCard,
    YourArticleInfoDialog
  },
  data() {
    return {
      yourArticleInfoDialog: false
    };
  }
};
</script>
